import { render, staticRenderFns } from "./ArticleHome.vue?vue&type=template&id=5245296a&"
import script from "./ArticleHome.vue?vue&type=script&lang=js&"
export * from "./ArticleHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports